import React, { Component } from "react";
import { Select } from "semantic-ui-react";
import Member from "../../models/Member";

class MemberSearchSelect extends Component {
    constructor(props) {
        super(props);
        this.state = {
            members: [],
            term: "",
            existingMembers: [],
            searchTimer: null,
        };

        this.additionalQueryParams = {};
    }

    async componentDidMount() {
        if ((this.props.value ?? null) === null) return;
        const include = Array.isArray(this.props.value)
            ? this.props.value
            : [this.props.value];
        if (include.length === 0) return;
        const members = await Member.list({
            include,
        });
        this.setState({ existingMembers: members, members });
    }

    async getMembers() {
        const { term } = this.state;
        let exclude = this.props.value;
        if (Array.isArray(exclude) === false) {
            exclude = [exclude];
        }

        this.additionalQueryParams = {};
        if (this.props.active === true) {
            this.additionalQueryParams.active = true;
        }

        if (this.props.hasUsableVoucher === true) {
            this.additionalQueryParams.hasUsableVoucher = true;
        }

        return Member.list(
            Object.assign({ term, exclude }, this.additionalQueryParams)
        );
    }

    onChangeSearch(value) {
        this.setState({ term: value });

        if (this.isLoading) {
            clearTimeout(this.state.searchTimer);
        }

        if (value.length === 0) {
            return this.setState({ searchTimer: null });
        }

        const searchTimer = setTimeout(async () => {
            const members = await this.getMembers();
            clearTimeout(this.state.searchTimer);
            return this.setState({
                searchTimer: null,
                members: members.concat(this.state.existingMembers),
            });
        }, 1000);

        this.setState({ searchTimer });
    }

    emptyListMessage() {
        if (this.isLoading) {
            return "Searching...";
        }

        if (this.state.term.length === 0) {
            return "Type to search for members";
        }

        return "No members found";
    }

    onChange(value) {
        const compareValue = Array.isArray(value) ? value : [value];
        const newExisting = [];
        for (const id of compareValue) {
            const existing = newExisting.some(({ _id }) => _id === id);
            if (existing === false) {
                const add =
                    this.state.members.find(({ _id }) => _id === id) ?? null;
                newExisting.push(add);
            }
        }

        this.setState({
            term: "",
            existingMembers: newExisting,
            members: newExisting,
        });
        this.props.onChange(value);
    }

    get isLoading() {
        return this.state.searchTimer !== null;
    }

    dropdownOptions() {
        const options = this.state.members.map((member, i) => ({
            key: i,
            text: `${member.name} (${member.email})`,
            value: member._id,
        }));

        return options;
    }

    render() {
        return (
            <Select
                placeholder={this.props.placeholder ?? "Search for members..."}
                icon="search"
                selection
                loading={this.isLoading}
                value={this.props.value}
                onSearchChange={({ target }) =>
                    this.onChangeSearch(target.value)
                }
                onChange={(_, props) => this.onChange(props.value)}
                search={(i) => i}
                multiple={this.props.multiple}
                options={this.dropdownOptions()}
                noResultsMessage={this.emptyListMessage()}
                disabled={this.props.disabled ?? false}
                fluid={this.props.fluid ?? false}
                className={"pr-2 " + this.props.className ?? ""}
            />
        );
    }
}

export default MemberSearchSelect;
